export default __webpack_public_path__ + "static/media/AMS_Dark2.0fdcff28.svg";